import { render, staticRenderFns } from "./Aneel12.vue?vue&type=template&id=27f1f4c0&"
import script from "./Aneel12.vue?vue&type=script&lang=js&"
export * from "./Aneel12.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports